define('home/models/SearchManager',[
    'underscore',
    'backbone',
    'core/UniqueModel',
    'home/models/Feed',
    'home/models/ActivityFeedItem',
    'home/models/Thread',
    'home/models/User',
    'home/models/Forum',
    'home/models/Post',
    'home/models/activities/TrendingThreadActivity',
    'home/collections/FeedItemCollection',

    'core/api',
], function (
    _,
    Backbone,
    UniqueModel,
    Feed,
    ActivityFeedItem,
    Thread,
    User,
    Forum,
    Post,
    TrendingThreadActivity,
    FeedItemCollection,

    api
) {
    'use strict';

    var SearchCollection = Backbone.Collection.extend({
        parse: function (resp) {
            return resp.response;
        },
    });

    var transformThread = function (thread) {
        thread = new Thread(thread);
        var model = new ActivityFeedItem({
            verb: 'trending',
        }, {
            activities: [new TrendingThreadActivity({
                id: thread.id,
                target: thread,
            })],
        });
        model.thread = thread;
        return model;
    };

    var ThreadSearchCollection = FeedItemCollection.extend({
        parse: function (resp) {
            return _.map(resp.response, transformThread);
        },

        // deliberately override because search api does not support pagination
        fetch: function (options) {
            return Backbone.Collection.prototype.fetch.call(this, options);
        },
    });

    return Backbone.Model.extend({
        initialize: function (attrs) {
            var searchUrl = api.getURL('users/search');
            var query = attrs.query;

            this.threads = new Feed({
                fetchOptions: {
                    obj_type: 'thread',
                    query: query,
                },
            }, {
                collection: new ThreadSearchCollection(),
                collectionUrl: searchUrl,
            });

            this.forums = new Feed({
                fetchOptions: {
                    obj_type: 'forum',
                    query: query,
                },
            }, {
                collection: new SearchCollection(null, {
                    model: UniqueModel.boundModel(Forum),
                }),
                collectionUrl: searchUrl,
            });

            this.users = new Feed({
                fetchOptions: {
                    obj_type: 'user',
                    query: query,
                },
            }, {
                collection: new SearchCollection(null, {
                    model: UniqueModel.boundModel(User),
                }),
                collectionUrl: searchUrl,
            });

            this.posts = new Feed({
                fetchOptions: {
                    obj_type: 'post',
                    query: query,
                },
            }, {
                collection: new SearchCollection(null, {
                    model: UniqueModel.boundModel(Post),

                }),
                collectionUrl: searchUrl,
            });

            this.myposts = new Feed({
                fetchOptions: {
                    obj_type: 'post',
                    query: query,
                    user: attrs.userId,
                },
            }, {
                collection: new SearchCollection(null, {
                    model: UniqueModel.boundModel(Post),

                }),
                collectionUrl: searchUrl,
            });
        },

        fetchSearchResults: function () {
            this.threads.fetchItems({ reset: true });
            this.forums.fetchItems({ reset: true });
            this.users.fetchItems({ reset: true });
            this.posts.fetchItems({ reset: true });
            this.myposts.fetchItems({ reset: true });
        },
    });
});

